<template>
    <div class="bg">
        <v-container>
          <div class="center nav">
            <v-icon style="position: absolute; left: 20px;color:#fff" @click="previous()"
              >mdi-arrow-left</v-icon
            >
            <v-spacer></v-spacer>
            <h2 style="margin-bottom: 0;color:#fff">Add Point</h2>
            <v-spacer></v-spacer>
          </div>

           <!-- content -->
          <div :style="`height:${height}px;min-height: 70vh;border-radius: 20px;background:#fff;overflow: scroll;`">
            <v-container>
                <div style="padding-top: 20px;">
                    <p>Item No.</p>
                    <v-text-field
                        placeholder="Enter  Item No."
                        solo
                        flat
                        hide-details
                        style="border-radius: 20px;
                        border: 2px solid var(--neutral-grey-5, #EFEEFC);
                        background: var(--neutral-white, #FFF);"
                    ></v-text-field>
                    <p><span style="color:#ff0000">* </span>Phone</p>
                     <v-text-field
                        placeholder="Enter  phone number"
                        solo
                        flat
                        hide-details
                        style="border-radius: 20px;
                        border: 2px solid var(--neutral-grey-5, #EFEEFC);
                        background: var(--neutral-white, #FFF);"
                    ></v-text-field>
                    <p>Amount of baht</p>
                    <v-text-field
                        placeholder="Choose amount of baht"
                        solo
                        flat
                        hide-details
                        style="border-radius: 20px;
                        border: 2px solid var(--neutral-grey-5, #EFEEFC);
                        background: var(--neutral-white, #FFF);"
                    ></v-text-field>
                </div>

                <div style="display:flex;justify-content:center;">
                    <v-btn block dark color="#25388D" class="btn-ok">Add Point</v-btn>
                </div>
            </v-container>
          </div>
          <!-- content -->
          <div class="foot">POWER BY  BETASK CONSULTING</div>
        </v-container>

    </div>
</template>

<script>
// import axios from 'axios' // api
export default {
  name: 'LoyaltySystemConvertRate',

  data () {
    return {
      height: '',
      ProductExchangeRate: [],
      session: this.$session.getAll()

    }
  },

  mounted () {
    this.checkDeviceHeight()
  },

  methods: {
    checkDeviceHeight () {
      // Get the viewport height
      const viewportHeight = window.innerHeight
      this.height = viewportHeight - 162
    },
    aa () {
      alert('aa')
    }

  }
}
</script>

<style scoped>
    .bg {
        background: #25388D;
        height: 100vh;
        width: 100%;
    }
    .nav {
  display: flex;
  align-items: center;
  height: 100px;
}

.foot {
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
}

p {
    color: #000;
    margin: 16px 0 0
}

/
.container {
    padding:12px 15px 0 15px;
}
.btn-ok{
    border-radius: 20px;
    height: 56px !important;
    position: absolute;
    bottom: 8%;

}
.v-btn--block {
    min-width: 85% !important;
}

.image {
    border-radius: 20px;
    background: var(--neutral-grey-5, #EEF3FC);
    width: 100%;
    height: 233px;
    flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/V2LOYALTY_REDESIGN/addpoint.vue